import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import PrimaryButton, { PrimaryButtonProps } from 'components/partials/buttons/primary-button';
import GatsbyImageTag from 'components/partials/parts/gatsby-image-tag';

/**
 * Suggested image size 405x538
 */
export type CalendarProps = {
    image?: IGatsbyImageData;
    imageAlt?: string;
    htmlContent: string;
};

const Calendar: React.FC<CalendarProps> = ({ image, imageAlt, htmlContent }) => (
    <div className="pattern pattern--alternating-rows">
        <div className="container">
            <div className={`image-content-row image-content-row--image-left`}>
                <div className="image-content-row__asset">
                    <GatsbyImageTag image={image} alt={imageAlt} lazy={true} />
                </div>

                <div className="image-content-row__content">
                    <div>
                        <div className="rtecontent" dangerouslySetInnerHTML={{ __html: htmlContent }} />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Calendar;